import { KEYS } from "@excalidraw/common";

import { CaptureUpdateAction } from "@excalidraw/element";

import { HelpIconThin, messageSparkIcon } from "../components/icons";

import { register } from "./register";

export const actionthreatcalidraw = register({
  name: "threatcalidraw",
  label: "Threat Modeller",
  icon: messageSparkIcon,
  viewMode: true,
  trackEvent: { category: "menu" },
  perform: (_elements, appState, _, { focusContainer }) => {
    return {
      appState: {
        ...appState,
        openDialog:
          appState.openDialog?.name === "threatcalidraw"
            ? null
            : {
                name: "threatcalidraw",
              },
        openMenu: null,
        openPopup: null,
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
});

export const actionShortcuts = register({
  name: "toggleShortcuts",
  label: "welcomeScreen.defaults.helpHint",
  icon: HelpIconThin,
  viewMode: true,
  trackEvent: { category: "menu", action: "toggleHelpDialog" },
  perform: (_elements, appState, _, { focusContainer }) => {
    if (appState.openDialog?.name === "help") {
      focusContainer();
    }
    return {
      appState: {
        ...appState,
        openDialog:
          appState.openDialog?.name === "help"
            ? null
            : {
                name: "help",
              },
        openMenu: null,
        openPopup: null,
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
  keyTest: (event) => event.key === KEYS.QUESTION_MARK,
});
